import axios from 'axios'

export default {
    namespaced: true,
    state: {
        bursaryApplication: {},
    },
    mutations: {
        SET_BURSARY_APPLICATION(state, payload) {
            state.bursaryApplication = payload;
        },
    },
    actions: {
        async FetchBursaryApplication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            commit('SET_BURSARY_APPLICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryApplication: ${error.message}`));
            });
        },
        async FetchBursaryApplicationByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/fetch/course-code`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);
                            resolve(response.data.payload);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryApplicationByCourseCode: ${error.message}`));
            });
        },
        async InsertBursaryApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertBursaryApplication: ${error.message}`));
            });
        },
        async UpdateBursaryApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateBursaryApplication: ${error.message}`));
            });
        },
        async UpdateBursaryApplicationBypassEvidenceFields({ }, obj) {
            obj.BypassEvidenceFields = StringifyJSON(obj.BypassEvidenceFields);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/update/bypass-evidence-fields`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateBursaryApplicationBypassEvidenceFields: ${error.message}`));
            });
        },
        async UpdateBursaryApplicationLastPageAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/update/last-page-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        //else reject(response.data.message);
                    }).catch(error => reject(`UpdateBursaryApplicationLastPageAccessed: ${error.message}`));
            });
        },
        async SubmitBursaryApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/submit`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`SubmitBursaryApplication: ${error.message}`));
            });
        },
        async CancelBursaryApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/cancel`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`CancelBursaryApplication: ${error.message}`));
            });
        },
        async DeleteBursaryApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteBursaryApplication: ${error.message}`));
            });
        },
    },
    getters: {
        BursaryApplication(state) { return state.bursaryApplication; },
    }
};

function HydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = CoalesceJSON(payload.benefitsReceived);
        payload.previousAddresses = CoalesceJSON(payload.previousAddresses);
        payload.otherOccupants = CoalesceJSON(payload.otherOccupants);
        payload.careExperienceTypes = CoalesceJSON(payload.careExperienceTypes);
        payload.studentHistory = CoalesceJSON(payload.studentHistory);
        payload.parentDependentChildrenDetails = CoalesceJSON(payload.parentDependentChildrenDetails);
        payload.parent1EmploymentHistoryDetails = CoalesceJSON(payload.parent1EmploymentHistoryDetails);
        payload.parent2EmploymentHistoryDetails = CoalesceJSON(payload.parent2EmploymentHistoryDetails);
        payload.partnerEmploymentHistoryDetails = CoalesceJSON(payload.partnerEmploymentHistoryDetails);
        payload.childrenDetails = CoalesceJSON(payload.childrenDetails);
        payload.discussApplicationPeople = CoalesceJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = CoalesceJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = CoalesceJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = CoalesceJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function DehydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = StringifyJSON(payload.benefitsReceived);
        payload.previousAddresses = StringifyJSON(payload.previousAddresses);
        payload.otherOccupants = StringifyJSON(payload.otherOccupants);
        payload.careExperienceTypes = StringifyJSON(payload.careExperienceTypes);
        payload.studentHistory = StringifyJSON(payload.studentHistory);
        payload.parentDependentChildrenDetails = StringifyJSON(payload.parentDependentChildrenDetails);
        payload.parent1EmploymentHistoryDetails = StringifyJSON(payload.parent1EmploymentHistoryDetails);
        payload.parent2EmploymentHistoryDetails = StringifyJSON(payload.parent2EmploymentHistoryDetails);
        payload.partnerEmploymentHistoryDetails = StringifyJSON(payload.partnerEmploymentHistoryDetails);
        payload.childrenDetails = StringifyJSON(payload.childrenDetails);
        payload.discussApplicationPeople = StringifyJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = StringifyJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = StringifyJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = StringifyJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function StringifyJSON(object) {
    if (object == null) return null;
    else if (typeof object == 'string') return object;
    else return JSON.stringify(object);
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};

